import UserProfileInformationsEntity from '@/entity/user-profile/UserProfileInformationsEntity';
import UserProExpEntity from '@/entity/UserProExpEntity';
import useProfessionalSkillService from '@/services/ProfessionalSkillService';
import { PropType, reactive } from 'vue';
import BaseSetupService from '../BaseSetupService';
import { useValidation } from '@orion.ui/orion';

type Props = SetupProps<typeof UserProfileProExpAsideNewSetupService.props>

export default class UserProfileProExpAsideNewSetupService extends BaseSetupService<Props> {
	static readonly props = {
		proExpToUpdate: {
			type: Object as PropType<UserProExpEntity>,
			default: undefined,
		},
		userProfileInformationsEntity: {
			type: Object as PropType<UserProfileInformationsEntity>,
			default: undefined,
		},
	};

	private _modal?: OrionModal;
	private readonly state = reactive({
		skillOptions: [] as IProfessionalSkillModel[],
		entity: new UserProExpEntity(),
	});

	validator?: any;

	get entity () { return this.state.entity; }
	get skillOptions () { return this.state.skillOptions; }
	get pageTitle () {
		return this.entity.isNew
			? `Ajout d'une nouvelle expérience`
			: `Modification de l'expérience`;
	}


	constructor (props: Props, _modal?: OrionModal) {
		super(props);
		this._modal = _modal;

		this.cloneProExpProp();
	}

	protected async onBeforeMountAsync (): Promise<void> {
		this.state.skillOptions = await useProfessionalSkillService().getAsync();
	}


	cloneProExpProp () {
		if (this.props.proExpToUpdate) {
			this.state.entity = this.props.proExpToUpdate.clone();
		}

		if (this.props.userProfileInformationsEntity) {
			this.entity.connectUserProfileInformationsEntity(this.props.userProfileInformationsEntity);
		}

		this.validator = useValidation(this.entity, {
			company: 'required',
			position: 'required',
			startDate: 'required',
			endDate: () => this.entity.isCurrentPosition ? true : !!this.entity.endDate,
		});
	}

	async addOrUpdateAsync () {
		if (!this.validator?.validate()) {
			this.validator?.showValidationState();
			return;
		}

		this.entity.isNew
			? await this.entity.createAsync()
			: await this.entity.updateAsync();

		this._modal?.trigger('added');
		this._modal?.close();
	}
}
